import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from './components/Dashboard/Dashboard';
import './App.css';
import './i18n/config'; // Initialize i18n

// Mock components for routes not yet implemented
const Login = () => <div className="p-8 text-center"><h1>Login Page</h1><p>Please log in to continue.</p></div>;
const CreatePost = () => <div className="p-8 text-center"><h1>Create Post</h1><p>Protected Route. You must be logged in.</p></div>;
const MissingPersons = () => <div className="p-8 text-center"><h1>Missing Persons</h1><p>List of missing persons.</p></div>;

// Simple Private Route wrapper
const PrivateRoute = ({ children }: { children: React.ReactElement }) => {
  const isAuthenticated = localStorage.getItem('auth_token') !== null;
  return isAuthenticated ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Public Access Routes */}
          <Route path="/" element={<Dashboard />} />
          <Route path="/login" element={<Login />} />
          <Route path="/missing-persons" element={<MissingPersons />} />

          {/* Protected Routes (Require Login) */}
          <Route
            path="/create-post"
            element={
              <PrivateRoute>
                <CreatePost />
              </PrivateRoute>
            }
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
